/**
 * @description: 呼叫服务报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="or-hf-report">
        <div class="hf-list">
            <div class="row row-margin">
                <label class="list-label-4">请求时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="hfTime">
                        <input type="text" class="form-control laydate-icon" v-model="hfStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="hfEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="hfShop" data-placeholder="请选择门店"></select>
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="hfperf_tit_sel">
                        <option value="accept_admin">接收员工</option>
                        <option value="finish_admin">完成员工</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="hfperf_con_val" :placeholder="hfperf_con_phd">
                </div>
                <div>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitHfTable" style="margin-right: 10px">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getHfExportSet">导出</button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2">
                    <input type="checkbox" v-model='hf_type' value="1">
                    <label>包含取消服务操作</label>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="hfList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="hfExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='hfExport_allcheck' @click='hfExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hfExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hfExport_checkModel' value="room_area_name">
                            <label>包厢区域</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hfExport_checkModel' value="room_name">
                            <label>包厢号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hfExport_checkModel' value="call_time">
                            <label>请求时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hfExport_checkModel' value="accept_time">
                            <label>接收时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hfExport_checkModel' value="accept_time_total">
                            <label>接收时长</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hfExport_checkModel' value="accept_admin">
                            <label>接收员工</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hfExport_checkModel' value="finish_time">
                            <label>完成时间</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hfExport_checkModel' value="finish_time_total">
                            <label>完成时长</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hfExport_checkModel' value="finish_admin">
                            <label>完成员工</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='hfExport_checkModel' value="total_time">
                            <label>总耗时</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='hfExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='hfExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                hfStartTime: "",
                hfEndTime: "",
                hfperf_field: "accept_admin",
                hfperf_con_phd: "接收员工姓名/工号",
                hfperf_con_val: "",
                hf_type: false,
                hfExport_allcheck: false,
                c_hfExport_allcheck: false,
                hfExport_checkModel: [],
                hfExport_checkData: ['shop_name', 'room_area_name', 'room_name', 'call_time', 'accept_time', 'accept_time_total', 'accept_admin', 'finish_time', 'finish_time_total', 'finish_admin', 'total_time'],
                hfExport_type: 1,
            }
        },
        watch: {
            hfExport_checkModel: {
                handler: function(val, oldVal) {
                    if(this.hfExport_checkModel.length >= this.hfExport_checkData.length) {
                        this.hfExport_allcheck = true;
                        this.c_hfExport_allcheck = true;
                    } else {
                        this.hfExport_allcheck = false;
                        this.c_hfExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.hfStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.hfEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            _this.innitDate(); // 日期
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 下拉选项
            $(_this.$refs.hfperf_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.hfperf_field = $(this).val();
                if(_this.hfperf_field == 'accept_admin') {
                    _this.hfperf_con_phd = '接收员工姓名/工号';
                } else if(_this.hfperf_field == 'finish_admin') {
                    _this.hfperf_con_phd = '完成员工姓名/工号';
                }
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.hfStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.hfEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.hfStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.hfEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.hfTime).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit : {
                        days : 31
                    },
                }, function(start, end, label) {
                    _this.hfStartTime = start.format('YYYY-MM-DD HH:mm');
                    _this.hfEndTime = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.hfShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.setShopDefaultTime(e.params.data.id)
                            });
                            $(_this.$refs.hfShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id)
                            _this.innitHfTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },



            // 呼叫服务报表表格
            innitHfTable: function() {
                let _this = this;
                $(_this.$refs.hfList).bootstrapTable('destroy');
                $(_this.$refs.hfList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 15,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getHfList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "130",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "room_area_name",
                        title: "包厢区域",
                        width: "7%"
                    }, {
                        field: "room_name",
                        title: "包厢号",
                        width: "7%"
                    }, {
                        field: "call_time",
                        title: "请求时间",
                        width: "100"
                    }, {
                        field: "accept_time",
                        title: "接收时间",
                        width: "100"
                    }, {
                        field: "accept_time_total",
                        title: "接收时长",
                        width: "10%"
                    }, {
                        field: "accept_admin",
                        title: "接收员工",
                        width: "7%"
                    }, {
                        field: "finish_time",
                        title: "完成时间",
                        width: "100"
                    }, {
                        field: "finish_time_total",
                        title: "完成时长",
                        width: "7%"
                    }, {
                        field: "finish_admin",
                        title: "完成员工",
                        width: "7%"
                    }, {
                        field: "total_time",
                        title: "总耗时",
                        width: "7%"
                    }],
                });
            },
            // 获取呼叫服务报表数据
            getHfList: function(params) {
                let _this = this,
                    type = '1',
                    shop_id = $(_this.$refs.hfShop).val(),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                if(_this.hf_type) {
                    type = '2';
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "type": type,
                            "start_date": _this.hfStartTime,
                            "end_date": _this.hfEndTime,
                            "shop_id": shop_id,
                            "key_word": _this.hfperf_field,
                            "search_word": _this.hfperf_con_val,
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getCallServerList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getHfExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/callServerListExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.hfExport_checkModel = data.response.result.export_fields;
                                _this.hfExport_type = data.response.result.export_type;
                            } else {
                                _this.hfExport_checkModel = _this.hfExport_checkData;
                                _this.hfExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.hfExport_alert)
                }, function() {
                    _this.exportHfList();
                });
            },
            // 导出字段全选
            hfExportCheckedAll: function() {
                let _this = this;
                _this.hfExport_allcheck = _this.c_hfExport_allcheck;
                if(!_this.hfExport_allcheck) { // 实现全选
                    _this.hfExport_checkModel = [];
                    _this.hfExport_checkData.forEach(function(item) {
                        _this.hfExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.hfExport_checkModel = [];
                }
            },
            // 导出呼叫服务报表
            exportHfList: function() {
                let _this = this,
                    type = '1',
                    shop_id = $(_this.$refs.hfShop).val();
                let export_fields = JSON.stringify(_this.hfExport_checkModel);
                if(_this.hf_type) {
                    type = '2';
                }
                window.location.href = Vue.ctUrl + "FinanceReport/callServerListExport?" +
                    "&type=" + type +
                    "&start_date=" + _this.hfStartTime +
                    "&end_date=" + _this.hfEndTime +
                    "&shop_id=" + shop_id +
                    "&key_word=" + _this.hfperf_field +
                    "&search_word=" + _this.hfperf_con_val +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.hfExport_type;
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>